import React from 'react';

export default ({ color = '#221CB6', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.55 1.5L2.75 6.9774H6.21665L5.95 10.5L10.75 5.0226H7.28335L7.55 1.5Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.5 2.5H4" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 9.5H4" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 4.5H1.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
